import React from 'react';

import FormSection from '@pb/kit-component-form-section';

import {SkeletonItem} from './skeleton-item';

type Props = {
    children: React.ReactNode,
    labelWidth: number,
};
export const FormSectionSkeleton = ({children, labelWidth}: Props) => (
    <FormSection headline="label" info={() => <SkeletonItem width={labelWidth} height={28}/>}>
        {children}
    </FormSection>
);
